import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import ListCreate from '../features/list_create'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL } from '../constants'

class ListCreatePage extends React.PureComponent {

  render() {
    const { children, isXS } = this.props
    
    const title = 'Create Feed'

    return (
      <DefaultLayout
        noRightSidebar
        showBackBtn
        title={title}
        page='list-create'
        noPullToRefresh
        sidebarChildren={!isXS ? <ListCreate showForm /> : undefined }
      >
        <PageTitle path={title} />
        {!isXS && children}
        
        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.bgPrimary, _s.px15].join(' ')}>
            <ListCreate showForm />
          </div>
        }
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

ListCreatePage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(ListCreatePage)